import { useTranslation } from 'i18n';
import { useState } from 'react';
import { Button, ListItemIcon, Menu, MenuItem } from 'ui';
import { ArrowDropDown, CameraAlt, Upload } from 'ui/icons';

type BaseProps = {
  onUpload: () => void;
};

type MobileProps = BaseProps & {
  isMobile: true;
  onOpenCamera: () => void;
};

type DesktopProps = BaseProps & {
  isMobile?: false;
  onOpenCamera?: () => void;
};

type UploadOptionsButtonProps = MobileProps | DesktopProps;

export const UploadOptionsButton = ({ onUpload, onOpenCamera, isMobile }: UploadOptionsButtonProps) => {
  const { t } = useTranslation('features');
  const [open, setOpen] = useState(false);

  const options = [
    {
      label: t('backlog.evidence.uploadOptionsButton.options.uploadPhoto'),
      onClick: () => {
        onUpload();
        setOpen(false);
      },
      startIcon: <Upload />,
    },
  ];

  if (isMobile && onOpenCamera) {
    options.push({
      label: t('backlog.evidence.uploadOptionsButton.options.openCamera'),
      onClick: () => {
        onOpenCamera();
        setOpen(false);
      },
      startIcon: <CameraAlt />,
    });
  }

  if (options.length > 1) {
    return (
      <Menu
        open={open}
        setOpen={setOpen}
        button={<Button endIcon={<ArrowDropDown />}>{t('backlog.evidence.uploadOptionsButton.actions.upload')}</Button>}
        equalMenuWidth={false}
      >
        {options.map((option) => (
          <MenuItem key={option.label} onClick={option.onClick}>
            <ListItemIcon>{option.startIcon}</ListItemIcon>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    );
  }

  return <Button onClick={onUpload}>{t('backlog.evidence.uploadOptionsButton.actions.upload')}</Button>;
};
